import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { get, post, patch } from "../../lib/request"
import { unwrapHotelSearchList } from "../../lib/utils/hotelSearchMappers";
 
// THUNK
export const searchProperty = createAsyncThunk(
    "AccountModel/searchProperty",
    async ({ brandId, query }, { rejectWithValue }) => {
        try {
 
            const url = `/authn/sub-brands/${brandId}/search?q=${encodeURIComponent(query)}`;
            const response = await get(url, null, { skipAuth: false });
            return unwrapHotelSearchList(response);
        } catch (error) {
            return rejectWithValue(error?.message || "API failed");
        }
    }
);
export const searchOrganization = createAsyncThunk(
    "AccountModel/searchOrganization",
    async ({ userId }, { rejectWithValue }) => {
        try {
 
            const response = await get(`/organizations/users/${userId}`);
            return response;
 
            return response || [];
        } catch (error) {
            return rejectWithValue(error?.message || "API failed");
        }
    }
);
 
export const searchBrand = createAsyncThunk(
    "AccountModel/searchBrand",
    async ({ page = 0, size = 100 } = {}, { rejectWithValue }) => {
        try {
 
            const url = `/authn/brands/search?page=${page}&size=${size}`;
 
            const response = await get(url, null, { skipAuth: false });
 
            return unwrapHotelSearchList(response);
 
        } catch (error) {
 
            return rejectWithValue(error?.message || "Brand API failed");
 
        }
    }
);
 
export const searchSocialNetwork = createAsyncThunk(
    "AccountModel/searchSocialNetwork",
    async (_, { rejectWithValue }) => {
        try {
            const url = `/social-network-types`;
            const res = await get(url, null, { skipAuth: false });
            return res;  // Should return the JSON array you shared
        } catch (err) {
            return rejectWithValue(err?.message);
        }
    }
);

export const searchCountry = createAsyncThunk(
    "AccountModel/searchCountry",
    async ({ query }, { rejectWithValue }) => {
        try {
            const url = `/authn/countries/search?q=${encodeURIComponent(query)}`;
            const response = await get(url, null, { skipAuth: false });
            return unwrapHotelSearchList(response);
        } catch (error) {
            return rejectWithValue(error?.message || "API failed");
        }
    }
);

export const searchState = createAsyncThunk(
    "AccountModel/searchState",
    async ({ countryId, query }, { rejectWithValue }) => {
        try {
            const response = await get(`/authn/state/${countryId}/search?q=${query}`);
            return response;
        } catch (err) {
            return rejectWithValue(err.message);
        }
    }
);

export const searchCity = createAsyncThunk(
    "AccountModel/searchCity",
    async ({ stateId, query }, { rejectWithValue }) => {
        try {
            const response = await get(`/authn/city/${stateId}/search?q=${query}`);
            return response;
        } catch (err) {
            return rejectWithValue(err.message);
        }
    }
);

export const createAccount = createAsyncThunk(
    "AccountModel/createAccount",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await post("/clients", payload, {
                skipAuth: false,
            });
 
            return res; // API success response
        } catch (error) {
            return rejectWithValue(error?.message || "Failed to create account");
        }
    }
);

export const updateAccount = createAsyncThunk(
    "AccountModel/updateAccount",
    async ({ clientId, payload }, { rejectWithValue }) => {
        try {
            if (clientId == null || clientId === "") {
                return rejectWithValue("clientId is required");
            }
            const res = await patch(`/clients/${clientId}`, payload, {
                skipAuth: false,
            });
            return res;
        } catch (error) {
            return rejectWithValue(error?.message || "Failed to update account");
        }
    }
);
// SLICE
const accountModelSlice = createSlice({
    name: "AccountModel",
    initialState: {
        suggestions: [],
        loadingSuggestions: false,
        suggestionsError: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(createAccount.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
            })
 
            // 🟢 SUCCESS
            .addCase(createAccount.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
            })
 
            // 🔴 ERROR
            .addCase(createAccount.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                state.success = false;
            })
            .addCase(searchProperty.pending, (state) => {
                state.loadingSuggestions = true;
                state.suggestionsError = null;
            })
            .addCase(searchProperty.fulfilled, (state, action) => {
                state.loadingSuggestions = false;
                state.suggestions = action.payload || [];
            })
 
            .addCase(searchProperty.rejected, (state, action) => {
                state.loadingSuggestions = false;
                state.suggestions = [];
                state.suggestionsError = action.payload;
            });
    },
});
 
export default accountModelSlice.reducer;